// https://stackoverflow.com/a/55251598/4268481
/**
 * Flatten a multidimensional object
 *
 * For example:
 *   flatten({ a: 1, b: { c: 2 } })
 * Returns:
 *   { a: 1, c: 2}
 */
const flatten = obj => {
    const flattened = {};

    Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            Object.assign(flattened, flatten(obj[key]));
        } else {
            flattened[key] = obj[key];
        }
    });

    return flattened;
};

export default flatten;
